import { ROLES } from "containers/ScopeContext/roles.enum";

type ApiKeyAccount = {
    role?: string;
    type?: string;
};

type AbilityCheck = {
    can: (action: string, subject: string) => boolean;
};

const platformAdminTypes = new Set(["admin", "superadmin"]);

/**
 * Matches POST /company/keys: owner or a platform admin, and both route permissions.
 * A custom role that only holds create CompanyApiKey must not see the button.
 */
export const canCreateApiKey = (account: ApiKeyAccount | null | undefined, ability: AbilityCheck): boolean => {
    const isOwnerOrPlatformAdmin = account?.role === ROLES.OWNER || platformAdminTypes.has(account?.type ?? "");
    return isOwnerOrPlatformAdmin && ability.can("update", "Company") && ability.can("create", "CompanyApiKey");
};
